var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHamburgerCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.625 22.125H7.375C7.375 22.125 7.375 7.375 29.5 7.375C51.625 7.375 51.625 22.125 51.625 22.125ZM32.8187 41.7917H7.375V44.25C7.375 48.3308 10.6692 51.625 14.75 51.625H32.8187C32.2779 50.0763 31.9583 48.4292 31.9583 46.7083C31.9583 44.9875 32.2779 43.3404 32.8187 41.7917ZM53.7392 33.7529C54.0312 33.0079 54.1371 32.2029 54.0475 31.4077C53.9578 30.6126 53.6755 29.8513 53.2249 29.19C52.7744 28.5287 52.1692 27.9873 51.462 27.613C50.7548 27.2386 49.9669 27.0425 49.1667 27.0417H27.0417L20.8958 31.9583L14.75 27.0417H9.83333C7.12917 27.0417 4.91667 29.2542 4.91667 31.9583C4.91667 34.6625 7.12917 36.875 9.83333 36.875H35.7442C38.4483 33.8758 42.3571 31.9583 46.7083 31.9583C49.265 31.9583 51.625 32.5975 53.7392 33.7529ZM52.4608 38.94L43.6354 47.7654L39.7267 43.8567L36.875 46.7083L43.6354 54.0833L55.3125 42.4063L52.4608 38.94Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 59,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerCheck);
export default __webpack_public_path__ + "static/media/hamburgerCheck.c7f6817c441e7b6a846f1f72fe9767a8.svg";
export { ForwardRef as ReactComponent };